const state = {
    displayMode: 'grid'
};

const mutations = {
    switchToCarousel(state) {
        state.displayMode = 'carousel';
    },

    switchToGrid(state) {
        state.displayMode = 'grid';
    },

    switchToList(state) {
        state.displayMode = 'list';
    },
};

export default {
    namespaced: true,
    state,
    mutations,
}
